import { AnalyticsController } from '~hooks/useAnalytics/AnalyticsController';
import { Order } from '~hooks/useOrders/models';

export enum OrderDispatchCardExpandedBlockTab {
  JOBS,
  TICKETS,
  ORDER_DETAILS,
  LIVE_MAP,
  TRUCK_REPLAY,
  TIMELINE,
  LOADS,
  METRICS,
  MESSAGING,
}

// snake_case names sent to PostHog as the `tab` property on `order_dispatch_tab_viewed`,
// so engagement (e.g. Truck Replay adoption) can be broken down by sub-tab. Mirrors the
// top-level `dispatch_tab_viewed` event fired in Dispatch.tsx.
const tabAnalyticsNames: Record<OrderDispatchCardExpandedBlockTab, string> = {
  [OrderDispatchCardExpandedBlockTab.JOBS]: 'jobs',
  [OrderDispatchCardExpandedBlockTab.TICKETS]: 'tickets',
  [OrderDispatchCardExpandedBlockTab.ORDER_DETAILS]: 'order_details',
  [OrderDispatchCardExpandedBlockTab.LIVE_MAP]: 'live_map',
  [OrderDispatchCardExpandedBlockTab.TRUCK_REPLAY]: 'truck_replay',
  [OrderDispatchCardExpandedBlockTab.TIMELINE]: 'timeline',
  [OrderDispatchCardExpandedBlockTab.LOADS]: 'loads',
  [OrderDispatchCardExpandedBlockTab.METRICS]: 'metrics',
  [OrderDispatchCardExpandedBlockTab.MESSAGING]: 'messaging',
};

export default function trackOrderDispatchTabViewed(
  order: Order,
  tab: OrderDispatchCardExpandedBlockTab,
  trigger: 'clicked' | 'expanded',
) {
  AnalyticsController.track('order_dispatch_tab_viewed', {
    order_id: order.id,
    order_friendly_id: order.orderId,
    tab: tabAnalyticsNames[tab],
    trigger,
  });
}
